import {
  cancellableApiRequest,
  get,
  getErrorMessage,
  post,
  put,
  uploadToPresignedUrl,
} from 'api'
import { compressImage } from 'helpers/common'
import {
  loginErrorInvalidEmail,
  loginErrorInvalidPassword,
} from 'helpers/const'
import { firebaseAuth, fireBase } from 'helpers/firebase'
import { message } from 'helpers/message'
import { history, routes } from 'routes/config'
import { auth } from 'store/types'
import { getCompanySubscription } from './company'

export const signup = (params, forOtp) => async (dispatch) => {
  try {
    if (forOtp && !params.otp && params.otp.toString().length < 6) {
      dispatch({
        type: auth.SETERROR,
        payload: { otpMessage: 'Please enter OTP' },
      })
      return
    }
    dispatch({
      type: auth.SETLOADING,
      payload: { signup: true },
    })
    const { data, status } = await post({
      subUrl: '/user/signup',
      data: params,
    })
    message.success(data.message)
    if (status === 206) {
      delete params.captchaToken
      dispatch({
        type: auth.STEPONE,
        payload: params,
      })
      history.replace(routes.verifyemailaddress.path)
      return false
    } else {
      dispatch({
        type: auth.SETERROR,
        payload: { otpMessage: '' },
      })
      // dispatch({
      //   type: auth.SIGNUP,
      //   payload: data?.data,
      // })
      return true
    }
  } catch (error) {
    const msg = getErrorMessage(error)
    if (params.otp) {
      dispatch({
        type: auth.SETERROR,
        payload: { otpMessage: msg },
      })
    }
    message.error(msg)
    throw error
  } finally {
    dispatch({
      type: auth.SETLOADING,
      payload: { signup: false },
    })
  }
}
const call = cancellableApiRequest()

export const getCompanies =
  ({ page, search, ...otherParams }) =>
  async (dispatch) => {
    try {
      const perPage = 20
      dispatch({
        type: auth.SETLOADING,
        payload: { getCompanies: true },
      })

      const { data } = await call(get, {
        subUrl: '/company/search',
        params: {
          page,
          perPage,
          str: search,
          ...otherParams,
        },
      })
      dispatch({
        type: auth.SETCOMPANIES,
        payload: {
          companies: data?.data?.companies,
          count: data?.data?.count,
          page,
          perPage,
        },
      })
    } catch (error) {
      const msg = getErrorMessage(error)
      message.error(msg)
    } finally {
      dispatch({
        type: auth.SETLOADING,
        payload: { getCompanies: false },
      })
    }
  }

//Not Using Below Server API for Login
export const login = (params) => async (dispatch) => {
  try {
    dispatch({
      type: auth.SETLOADING,
      payload: { login: true },
    })
    const { data } = await post({
      subUrl: '/user/login',
      data: params,
    })
    message.success(data.message)
    dispatch({
      type: auth.LOGIN,
      payload: data?.data,
    })
    history.push(routes.index.path)
  } catch (error) {
    const msg = getErrorMessage(error)
    message.error(msg)
  } finally {
    dispatch({
      type: auth.SETLOADING,
      payload: { login: false },
    })
  }
}

export const assignOrgToUser = (data) => async (dispatch) => {
  try {
    await post({
      subUrl: '/user/assign-organization',
      data,
    })
    await validateUser()(dispatch)
  } catch (error) {
    if (error?.isAxiosError) {
      const msg = getErrorMessage(error)
      return message.error(msg)
    }
    return message.error(error?.message)
  }
}

export const addAndAssignOrg = (data) => async (dispatch) => {
  try {
    await post({
      subUrl: '/user/add-and-assign-organization',
      data,
    })
    await validateUser()(dispatch)
  } catch (error) {
    if (error?.isAxiosError) {
      const msg = getErrorMessage(error)
      return message.error(msg)
    }
    return message.error(error?.message)
  }
}

export const verifyEmailOtp = (otp) => async (dispatch) => {
  try {
    dispatch({
      type: auth.SETLOADING,
      payload: { verifyOtp: true },
    })
    const { data } = await post({
      subUrl: '/user/verify-otp',
      data: { otp },
    })
    message.success(data.message)
    dispatch({
      type: auth.SETUSER,
      payload: { user: data.data },
    })
    history.push(routes.index.path)
  } catch (error) {
    const msg = getErrorMessage(error)
    message.error(msg)
  } finally {
    dispatch({
      type: auth.SETLOADING,
      payload: { verifyOtp: false },
    })
  }
}

export const resendVerifyEmail = (email) => async (dispatch) => {
  try {
    dispatch({
      type: auth.SETLOADING,
      payload: { resendOtp: true },
    })
    const { data } = await post({
      subUrl: '/user/send-verify-email',
      data: { email },
    })
    message.success(data.message)
  } catch (error) {
    const msg = getErrorMessage(error)
    message.error(msg)
  } finally {
    dispatch({
      type: auth.SETLOADING,
      payload: { resendOtp: false },
    })
  }
}

export const switchCompany =
  (userOrganizationId) => async (dispatch, getState) => {
    try {
      const authState = getState().auth
      dispatch({
        type: auth.SETLOADING,
        payload: { switchCompany: true },
      })
      const { data } = await post({
        subUrl: '/user/switch-company',
        data: {
          userOrganizationId,
        },
      })
      // dispatch({
      //   type: auth.SWITCH_COMPANY,
      //   payload: { loading: {...authState.loading, switchCompany:false}, user: {...authState.user, ...data.data } },
      // })
      window.location.reload()

      // history.push(routes.index.path)
    } catch (err) {
      message.error('Unable to change company at the moment')
    } finally {
      dispatch({
        type: auth.SETLOADING,
        payload: { switchCompany: false },
      })
    }
  }

export const firebaseLogin =
  ({ email, password }, redirectTo) =>
  async (dispatch) => {
    try {
      dispatch({
        type: auth.SETLOADING,
        payload: { login: true },
      })
      let { user } = await firebaseAuth.signInWithEmailAndPassword(
        email,
        password
      )
      user = user.toJSON()
      const accessToken = user.stsTokenManager.accessToken
      await post({
        subUrl: '/auth/login',
        apiVersion: 'v2',
        data: {
          accessToken,
        },
        withCredentials: true,
      })
      const { data: userData } = await get({
        subUrl: '/auth/user',
        apiVersion: 'v2',
        withCredentials: true,
      })

      await getCompanySubscription()(dispatch)

      dispatch({
        type: auth.LOGIN,
        payload: { user: userData },
      })

      const pendingGoogleLink = sessionStorage.getItem('pendingGoogleLink')
      const pendingMicrosoftLink = sessionStorage.getItem('pendingMicrosoftLink')
      const pendingAppleLink = sessionStorage.getItem('pendingAppleLink')
      const pendingCredential = sessionStorage.getItem('pendingCredential')
      
      if ((pendingGoogleLink === 'true' || pendingMicrosoftLink === 'true' || pendingAppleLink === 'true') && pendingCredential) {
        dispatch({
          type: auth.SET_LINK_ACCOUNT_MODAL,
          payload: {
            visible: false,
            email: '',
            provider: '',
          }
        })
        
        try {
          const credential = JSON.parse(pendingCredential)
          let authCredential
          let providerName = ''
          
          if (pendingGoogleLink === 'true') {
            authCredential = fireBase.auth.GoogleAuthProvider.credential(
              credential.idToken,
              credential.accessToken
            )
            providerName = 'Google'
          } else if (pendingMicrosoftLink === 'true') {
            authCredential = new fireBase.auth.OAuthProvider('microsoft.com').credential({
              idToken: credential.idToken,
              accessToken: credential.accessToken
            })
            providerName = 'Microsoft'
          } else if (pendingAppleLink === 'true') {
            authCredential = new fireBase.auth.OAuthProvider('apple.com').credential({
              idToken: credential.idToken,
              accessToken: credential.accessToken
            })
            providerName = 'Apple'
          }
          
          await firebaseAuth.currentUser.linkWithCredential(authCredential)
          
          const accessToken = await firebaseAuth.currentUser.getIdToken(true)
          const providerKey = providerName.toLowerCase()
          
          await post({
            subUrl: '/auth/login',
            apiVersion: 'v2',
            data: {
              accessToken,
              provider: providerKey,
            },
            withCredentials: true,
          })
          
          sessionStorage.removeItem('pendingGoogleLink')
          sessionStorage.removeItem('pendingMicrosoftLink')
          sessionStorage.removeItem('pendingAppleLink')
          sessionStorage.removeItem('pendingLinkEmail')
          sessionStorage.removeItem('pendingCredential')
          
          message.success(`${providerName} account linked successfully!`)
        } catch (linkError) {
          console.error('Error linking provider:', linkError)
          
          if (linkError.code === 'auth/credential-already-in-use') {
            message.error('This account is already linked to another user.')
          } else if (linkError.code === 'auth/provider-already-linked') {
            message.info('This provider is already linked to your account.')
          } else {
            message.error('Failed to link account. Please try again.')
          }
          
          sessionStorage.removeItem('pendingGoogleLink')
          sessionStorage.removeItem('pendingMicrosoftLink')
          sessionStorage.removeItem('pendingAppleLink')
          sessionStorage.removeItem('pendingLinkEmail')
          sessionStorage.removeItem('pendingCredential')
        }
      }

      dispatch({
        type: auth.SETLOADING,
        payload: { login: false },
      })

      if (redirectTo) {
        return (window.location.href = redirectTo)
      }
      
      history.push(routes.index.path)
    } catch (error) {
      if (error?.code === loginErrorInvalidEmail.code) {
        message.error(loginErrorInvalidEmail.message)
      } else if (error?.code === loginErrorInvalidPassword.code) {
        message.error(loginErrorInvalidPassword.message)
      } else if (error?.isAxiosError) {
        const msg = getErrorMessage(error)
        message.error(msg)
      } else {
        message.error(error?.message)
      }
      dispatch({
        type: auth.SETLOADING,
        payload: { login: false },
      })
    }
  }

export const firebaseCommunityLogin =
  ({ email, password, communityId }) =>
  async (dispatch) => {
    try {
      dispatch({
        type: auth.SETLOADING,
        payload: { login: true },
      })
      let { user } = await firebaseAuth.signInWithEmailAndPassword(
        email,
        password
      )
      user = user.toJSON()
      const accessToken = user.stsTokenManager.accessToken
      const { data } = await get({
        subUrl: '/user',
        headers: { Authorization: `Bearer ${accessToken}` },
      })
      dispatch({
        type: auth.LOGIN,
        payload: { ...user.stsTokenManager, user: data.data },
      })
      history.push(routes.communityDetailPage.path_string(communityId))
    } catch (error) {
      if (error?.code === loginErrorInvalidEmail.code) {
        message.error(loginErrorInvalidEmail.message)
      } else if (error?.code === loginErrorInvalidPassword.code) {
        message.error(loginErrorInvalidPassword.message)
      } else if (error?.isAxiosError) {
        const msg = getErrorMessage(error)
        message.error(msg)
      } else {
        message.error(error?.message)
      }
    } finally {
      dispatch({
        type: auth.SETLOADING,
        payload: { login: false },
      })
    }
  }

export const validateUser = () => async (dispatch) => {
  try {
    let sessionToken = null
    dispatch({
      type: auth.SETLOADING,
      payload: { user: true },
    })

    const { data: sessionData } = await post({
      subUrl: '/auth/validate-session',
      apiVersion: 'v2',
      withCredentials: true,
    })
    sessionToken = sessionData.token

    await firebaseAuth.signInWithCustomToken(sessionToken)
    const { data: userData } = await get({
      subUrl: '/auth/user',
      apiVersion: 'v2',
      withCredentials: true,
    })

    await getCompanySubscription()(dispatch)

    // if (!userData.isActive && userData.companyId) {
    //   switch (userData.activationStatus) {
    //     case 'pending-approval': {
    //       triggerNoAccessModal({
    //         visible: true,
    //         title: 'No Access',
    //         message:
    //           'Your account is going through an approval process with the Company Admin. Try again later.',
    //       })(dispatch)
    //       break
    //     }
    //     case 'deactivated': {
    //       triggerNoAccessModal({
    //         visible: true,
    //         title: 'No Access',
    //         message: 'Your account has been deactivated.',
    //       })(dispatch)
    //       break
    //     }
    //     default:
    //   }
    //   return logout()(dispatch)
    // }
    dispatch({
      type: auth.LOGIN,
      payload: {
        user: userData,
      },
    })
  } catch (error) {
    // const msg = getErrorMessage(error)
    // message.error(msg)
    throw error
  } finally {
    dispatch({
      type: auth.SETLOADING,
      payload: { user: false },
    })
  }
}

export const logout = () => async (dispatch) => {
  await post({
    subUrl: '/auth/sign-out',
    apiVersion: 'v2',
    withCredentials: true,
  })
  await firebaseAuth.signOut()
  dispatch({
    type: auth.RESET,
  })
  dispatch({
    type: auth.RESET_ALL,
  })
}

export const updatePassword =
  ({ oldPassword, newPassword, userId, email }) =>
  async (dispatch) => {
    try {
      if (!newPassword || !newPassword.length) {
        message.error('New password is required')
        return
      }
      dispatch({
        type: auth.SETLOADING,
        payload: { updatingUserPassword: false },
      })
      const cred = fireBase.auth.EmailAuthProvider.credential(
        email,
        oldPassword
      )
      await firebaseAuth.currentUser.reauthenticateWithCredential(cred)
      const checkForNewpass = fireBase.auth.EmailAuthProvider.credential(
        email,
        newPassword
      )
      try {
        const data =
          await firebaseAuth.currentUser.reauthenticateWithCredential(
            checkForNewpass
          )
        if (data.user) {
          message.error('New password should not be same as old password')
          return
        }
      } catch (error) {
        //New password not same as old password  continue
      }
      await firebaseAuth.currentUser.updatePassword(newPassword)
      await post({
        subUrl: '/user/on-password-update',
        data: { userId, password: newPassword },
      })
      message.success('Password updated successfully.')
    } catch (error) {
      let msg
      if (error.isAxiosError) {
        msg = getErrorMessage(error)
      } else {
        msg = error.message
      }
      message.error(msg)
    } finally {
      dispatch({
        type: auth.SETLOADING,
        payload: { updatingUserPassword: false },
      })
    }
  }

export const updateUser =
  ({
    firstname,
    lastname,
    email,
    oldPassword,
    newPassword,
    jobTitle,
    contactNumber,
    userImage,
    userId,
  }) =>
  async (dispatch) => {
    try {
      dispatch({
        type: auth.SETLOADING,
        payload: { updateUser: true },
      })
      let data
      if (firstname || lastname || jobTitle || contactNumber || userImage) {
        ;({ data } = await put({
          subUrl: '/user',
          data: { firstname, lastname, jobTitle, contactNumber },
        }))
        dispatch({
          type: auth.UPDATEUSER,
          payload: { user: data.data },
        })
      }
      data?.message && message.success(data?.message)
      return true
    } catch (error) {
      let msg
      if (error.isAxiosError) {
        msg = getErrorMessage(error)
      } else {
        msg = error.message
      }
      message.error(msg)
    } finally {
      dispatch({
        type: auth.SETLOADING,
        payload: { updateUser: false },
      })
    }
  }

export const updateProfilePicture = (file) => async (dispatch) => {
  try {
    dispatch({
      type: auth.SETLOADING,
      payload: { uploadImage: true },
    })
    if (file === null) {
      const { data: updatedUser } = await put({
        subUrl: '/user/',
        data: { userImage: '' },
      })
      dispatch({
        type: auth.SETIMAGE,
        payload: updatedUser?.data?.userImage,
      })
    } else {
      const { data } = await get({
        subUrl: '/user/get-user-img-presigned-url',
        params: { fileName: file.name },
      })
      // const smallImage = await compressImage(file) image compression disabled
      const { url, key } = data.data
      await uploadToPresignedUrl(url, file)
      const { data: updatedUser } = await put({
        subUrl: '/user/',
        data: { userImage: key },
      })
      dispatch({
        type: auth.SETIMAGE,
        payload: updatedUser?.data?.userImage,
      })
    }
  } catch (error) {
    message.error(error?.message)
    message.error(error?.response?.message)
    const msg = getErrorMessage(error)
    message.error(msg)
  } finally {
    dispatch({
      type: auth.SETLOADING,
      payload: { uploadImage: false },
    })
  }
}

export const setupPassword = ({ password, email }) => async (dispatch) => {
  try {
    dispatch({
      type: auth.SETLOADING,
      payload: { setupPassword: true },
    })

    // Step 1: Link the password credential with the existing SSO account in Firebase
    // This must happen first to avoid session invalidation
    const credential = fireBase.auth.EmailAuthProvider.credential(
      email,
      password
    )
    await firebaseAuth.currentUser.linkWithCredential(credential)

    // Step 2: Update backend database to record the password provider
    await post({
      subUrl: '/user/setup-password',
      data: { password },
    })

    message.success('Password setup successful! You can now login with email and password.')
    return true
  } catch (error) {
    let msg
    if (error.isAxiosError) {
      msg = getErrorMessage(error)
    } else if (error.code === 'auth/provider-already-linked') {
      msg = 'Password authentication is already linked to this account'
    } else if (error.code === 'auth/credential-already-in-use') {
      msg = 'This credential is already associated with a different account'
    } else if (error.code === 'auth/weak-password') {
      msg = 'Password is too weak. Please use a stronger password.'
    } else {
      msg = error.message
    }
    message.error(msg)
    return false
  } finally {
    dispatch({
      type: auth.SETLOADING,
      payload: { setupPassword: false },
    })
  }
}

export const becomeMember = (params) => async (dispatch) => {
  try {
    dispatch({
      type: auth.SETLOADING,
      payload: { becomeMember: true },
    })
    await post({ subUrl: '/team/become-member', data: params })
    const { data } = await get({ subUrl: '/user' })
    dispatch({
      type: auth.UPDATEUSER,
      payload: { user: data.data },
    })
    return true
  } catch (error) {
    const msg = getErrorMessage(error)
    message.error(msg)
  } finally {
    dispatch({
      type: auth.SETLOADING,
      payload: { becomeMember: false },
    })
  }
}

export const removeError = () => (dispatch) => {
  dispatch({
    type: auth.SETERROR,
    payload: { otpMessage: '' },
  })
}

export const getInvite = (params) => async (dispatch) => {
  try {
    dispatch({
      type: auth.SETLOADING,
      payload: { getInvite: true },
    })
    const { data } = await get({ subUrl: '/team/invite', params })
    dispatch({
      type: auth.SETINVITE,
      payload: data.data,
    })
    return data.data
  } catch (error) {
    const msg = getErrorMessage(error)
    message.error(msg)
    return false
  } finally {
    dispatch({
      type: auth.SETLOADING,
      payload: { getInvite: false },
    })
  }
}

export const acceptInvite = (params) => async (dispatch) => {
  try {
    dispatch({
      type: auth.SETLOADING,
      payload: { signup: true },
    })
    const { data, status } = await post({
      subUrl: '/team/accept',
      data: params,
    })
    message.success(data.message)
    if (status === 206) {
      dispatch({
        type: auth.STEPONE,
        payload: params,
      })
      history.replace(
        `${routes.verifyemailaddress.path}?invite=${params.inviteCode}`
      )
      return false
    } else {
      dispatch({
        type: auth.SETERROR,
        payload: { otpMessage: '' },
      })
      return true
    }
  } catch (error) {
    const msg = getErrorMessage(error)
    if (params.otp) {
      dispatch({
        type: auth.SETERROR,
        payload: { otpMessage: msg },
      })
    } else {
      message.error(msg)
    }
  } finally {
    dispatch({
      type: auth.SETLOADING,
      payload: { signup: false },
    })
  }
}

export const setNoTeamModal = (params) => (dispatch) => {
  dispatch({
    type: auth.NO_TEAM_MODAL,
    payload: params,
  })
}
export const leaveTeam = (params) => (dispatch) => {
  dispatch({
    type: auth.LEAVE_TEAM,
  })
}

export const updateLiveStreamStatus = (status) => async (dispatch) => {
  try {
    dispatch({
      type: auth.LIVE_STREAM_STATUS,
      payload: status,
    })
    return true
  } catch (e) {
    throw e
  }
}

export const getNotificiationCount = () => async (dispatch) => {
  try {
    const data = (
      await get({
        subUrl: '/user',
      })
    ).data.data.notification_count
    dispatch({
      type: auth.SET_NOTIFICATION_COUNT,
      payload: {
        notification_count: data,
      },
    })
  } catch (e) {
    throw e
  }
}

export const getUser = () => async (dispatch, getState) => {
  try {
    const { accessToken, refreshToken } = getState().auth
    return validateUser({
      accessToken,
      refreshToken,
    })(dispatch)
  } catch (error) {
    throw error
  }
}

export const triggerNoAccessModal = (data) => (dispatch) => {
  dispatch({
    type: auth.SET_NO_ACCESS_MODAL,
    payload: data,
  })
}

export const triggerChromeExtensionModal = (data) => (dispatch) => {
  dispatch({
    type: auth.CHROME_EXTENSION_BAR,
  })
}

// Action to close link account modal
export const closeLinkAccountModal = () => (dispatch) => {
  dispatch({
    type: auth.SET_LINK_ACCOUNT_MODAL,
    payload: {
      visible: false,
      email: '',
      provider: '',
    }
  })
  sessionStorage.removeItem('pendingGoogleLink')
  sessionStorage.removeItem('pendingMicrosoftLink')
  sessionStorage.removeItem('pendingAppleLink')
  sessionStorage.removeItem('pendingLinkEmail')
  sessionStorage.removeItem('pendingCredential')
}

// Social Login Functions
export const signupWithGoogle = () => async (dispatch) => {
  try {
    dispatch({
      type: auth.SETLOADING,
      payload: { googleLogin: true },
    })
    
    const provider = new fireBase.auth.GoogleAuthProvider()
    provider.addScope('email')
    provider.addScope('profile')
    
    const result = await firebaseAuth.signInWithPopup(provider)
    
    if (!result || !result.user) {
      throw new Error('Authentication failed')
    }
    
    const credential = result.credential || fireBase.auth.GoogleAuthProvider.credentialFromResult(result)
    
    const user = result.user.toJSON()
    const email = user.providerData && user.providerData[0] ? user.providerData[0].email : user.email
    
    if (!email) {
      throw new Error('Unable to retrieve email from Google account')
    }
    
    const { data: checkUserData } = await post({
      subUrl: '/auth/check-user-exists',
      apiVersion: 'v2',
      data: { email },
    })
    
    const isGoogleLinked = checkUserData.linkedProviders && checkUserData.linkedProviders.includes('google')
    
    if (checkUserData.exists && checkUserData.hasPasswordProvider && !isGoogleLinked) {
      // User exists with password provider but Google is not linked - need to link accounts
      
      // Store the credential before deleting the user
      if (credential) {
        sessionStorage.setItem('pendingCredential', JSON.stringify({
          idToken: credential.idToken,
          accessToken: credential.accessToken,
        }))
      }
      
      await result.user.delete()
      
      sessionStorage.setItem('pendingGoogleLink', 'true')
      sessionStorage.setItem('pendingLinkEmail', email)
      
      dispatch({
        type: auth.SET_LINK_ACCOUNT_MODAL,
        payload: {
          visible: true,
          email,
          provider: 'Google',
        },
      })
      
      dispatch({
        type: auth.SETLOADING,
        payload: { googleLogin: false },
      })
      return
    }
    
    const accessToken = user.stsTokenManager.accessToken
    
    if (!accessToken) {
      throw new Error('Failed to get access token')
    }
    
    // Call backend to create session cookie
    await post({
      subUrl: '/auth/login',
      apiVersion: 'v2',
      data: {
        accessToken,
        provider: 'google',
      },
      withCredentials: true,
    })
    
    // Get user data from backend
    const { data: userData } = await get({
      subUrl: '/auth/user',
      apiVersion: 'v2',
      withCredentials: true,
    })
    
    await getCompanySubscription()(dispatch)
    
    // Update Redux state with user data
    dispatch({
      type: auth.LOGIN,
      payload: { user: userData },
    })
    
    message.success('Successfully signed in with Google!')
    
    // Small delay to ensure session cookie is properly set before navigation
    await new Promise(resolve => setTimeout(resolve, 100))
    
    history.push(routes.index.path)
  } catch (error) {
    console.error('Google signup error:', error)
    
    if (error.code === 'auth/popup-closed-by-user') {
      message.info('Sign-in cancelled')
    } else if (error.code === 'auth/popup-blocked') {
      message.error('Popup was blocked. Please allow popups for this site.')
    } else if (error.code === 'auth/cancelled-popup-request') {
      // User opened multiple popups, ignore this error
      return
    } else if (error.code === 'auth/credential-already-in-use') {
      message.error('This Google account is already linked to another user.')
    } else {
      const msg = getErrorMessage(error)
      message.error(msg || 'Failed to sign in with Google')
    }
  } finally {
    dispatch({
      type: auth.SETLOADING,
      payload: { googleLogin: false },
    })
  }
}

export const signupWithMicrosoft = () => async (dispatch) => {
  try {
    dispatch({
      type: auth.SETLOADING,
      payload: { microsoftLogin: true },
    })
    
    const provider = new fireBase.auth.OAuthProvider('microsoft.com')
    const result = await firebaseAuth.signInWithPopup(provider)
    
    if (!result || !result.user) {
      throw new Error('Authentication failed')
    }
    
    const user = result.user.toJSON()
    const email = user.email
    
    if (!email) {
      await result.user.delete()
      
      message.warning('An account with this email already exists. Please sign in with your password first.')
      
      sessionStorage.setItem('pendingMicrosoftLink', 'true')
      
      dispatch({
        type: auth.SETLOADING,
        payload: { microsoftLogin: false },
      })
      return
    }
    
    const accessToken = user.stsTokenManager.accessToken
    
    if (!accessToken) {
      throw new Error('Failed to get access token')
    }
    
    await post({
      subUrl: '/auth/login',
      apiVersion: 'v2',
      data: {
        accessToken,
      },
      withCredentials: true,
    })
    
    const { data: userData } = await get({
      subUrl: '/auth/user',
      apiVersion: 'v2',
      withCredentials: true,
    })
    
    await getCompanySubscription()(dispatch)
    
    dispatch({
      type: auth.LOGIN,
      payload: { user: userData },
    })
    
    message.success('Successfully signed in with Microsoft!')
    history.push(routes.index.path)
  } catch (error) {
    console.error('Microsoft signup error:', error)
    
    if (error.code === 'auth/popup-closed-by-user') {
      message.info('Sign-in cancelled')
    } else if (error.code === 'auth/popup-blocked') {
      message.error('Popup was blocked. Please allow popups for this site.')
    } else if (error.code === 'auth/cancelled-popup-request') {
      return
    } else if (error.code === 'auth/credential-already-in-use') {
      message.error('This Microsoft account is already linked to another user.')
    } else {
      const msg = getErrorMessage(error)
      message.error(msg || 'Failed to sign in with Microsoft')
    }
  } finally {
    dispatch({
      type: auth.SETLOADING,
      payload: { microsoftLogin: false },
    })
  }
}

export const signupWithApple = () => async (dispatch) => {
  try {
    dispatch({
      type: auth.SETLOADING,
      payload: { appleLogin: true },
    })
    
    const provider = new fireBase.auth.OAuthProvider('apple.com')
    const result = await firebaseAuth.signInWithPopup(provider)
    
    if (!result || !result.user) {
      throw new Error('Authentication failed')
    }
    
    const user = result.user.toJSON()
    const email = user.email
    
    // Check if email is null - this happens when account exists with different provider
    if (!email) {
      // Delete the newly created account
      await result.user.delete()
      
      // Prompt user to sign in with password first
      message.warning('An account with this email already exists. Please sign in with your password first.')
      
      // Store intent to link Apple after password login
      sessionStorage.setItem('pendingAppleLink', 'true')
      
      dispatch({
        type: auth.SETLOADING,
        payload: { appleLogin: false },
      })
      return
    }
    
    const accessToken = user.stsTokenManager.accessToken
    
    if (!accessToken) {
      throw new Error('Failed to get access token')
    }
    
    await post({
      subUrl: '/auth/login',
      apiVersion: 'v2',
      data: {
        accessToken,
      },
      withCredentials: true,
    })
    
    const { data: userData } = await get({
      subUrl: '/auth/user',
      apiVersion: 'v2',
      withCredentials: true,
    })
    
    await getCompanySubscription()(dispatch)
    
    dispatch({
      type: auth.LOGIN,
      payload: { user: userData },
    })
    
    message.success('Successfully signed in with Apple!')
    history.push(routes.index.path)
  } catch (error) {
    console.error('Apple signup error:', error)
    
    if (error.code === 'auth/popup-closed-by-user') {
      message.info('Sign-in cancelled')
    } else if (error.code === 'auth/popup-blocked') {
      message.error('Popup was blocked. Please allow popups for this site.')
    } else if (error.code === 'auth/cancelled-popup-request') {
      return
    } else if (error.code === 'auth/credential-already-in-use') {
      message.error('This Apple account is already linked to another user.')
    } else {
      const msg = getErrorMessage(error)
      message.error(msg || 'Failed to sign in with Apple')
    }
  } finally {
    dispatch({
      type: auth.SETLOADING,
      payload: { appleLogin: false },
    })
  }
}
